import { useQuery, useMutation } from 'react-apollo';

import { AlbumFolderForYearbookSettings } from '../../../graphql/queries/album-folder';
import { albumFolderUpdate as albumFolderUpdateMutation } from '../../../graphql/mutations/album-folder';

const useAlbumFolderYearbookSettings = ({ albumFolderId }) => {
  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderForYearbookSettings,
    {
      variables: {
        id: albumFolderId,
      },
      skip: !albumFolderId,
      fetchPolicy: 'network-only',
    },
  );

  const [albumFolderUpdate] = useMutation(albumFolderUpdateMutation);

  const onUpdateAlbumFolderYearbookSettings = async ({ yearbookSettings }) => {
    const result = await albumFolderUpdate({
      variables: {
        input: {
          album_folder_id: albumFolderId,
          yearbook_settings: {
            ...yearbookSettings,
          },
        },
      },
    });

    return result;
  };

  return {
    albumFolder,
    onUpdateAlbumFolderYearbookSettings,
  };
};

export default useAlbumFolderYearbookSettings;
